module.exports = __webpack_public_path__ + "img/thumbnail_Gharial_f_normal.563b9916.png";